import { ChangeDetectorRef, Component, HostListener, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { ModalController } from "@ionic/angular";
import { SharedServices } from "src/app/services/shared.service";
import { LeadsService } from "src/app/services/leads.service";
import { EncryptionService } from "src/app/services/encryption.service";
import { AbstractControl, FormBuilder, ValidationErrors, Validators } from "@angular/forms";
import { ExportPropertyLeadsComponent } from "src/app/modules/agent/pages/property-list/components/export-property-leads/export-property-leads.component";
import { MatDialog } from "@angular/material/dialog";
import { DialogLinkLeadComponent } from "../dialog-link-lead/dialog-link-lead.component";
import { domain } from "src/app/variables/domain";
import { AgentCityComponent } from "../agent-city/agent-city.component";
@Component({
  selector: "app-sub-header-toolbar",
  templateUrl: "./sub-header-toolbar.component.html",
  styleUrls: ["./sub-header-toolbar.component.scss"],
  standalone: false
})
export class SubHeaderToolbarComponent implements OnInit {
  @Input() title: string = '';
  @Input() isVisible: boolean = true;
  // isUserLoggedIn: boolean;
  isLeadSelected: any = "Lead";
  isLoggedIn: any = this.sharedServices.getLogedIn();
  isAgent: any;
  isLargeScreen: boolean = false;
  isImagePreview: boolean = false;
  canDismiss = false;
  // isSubExpired: any;
  minDate = new Date(2020, 0, 1);
  maxDate = new Date(2030, 11, 31);
  selectedCity: any;

  form = this.fb.group(
    {
      range: this.fb.group({
        start: [null, Validators.required],
        end: [null, Validators.required],
      }),
    },
    { validators: this.rangeValidator }
  );

  constructor(
    public router: Router,
    private location: Location,
    private modalCtrl: ModalController,
    private sharedServices: SharedServices,
    private leadService: LeadsService,
    private cd: ChangeDetectorRef,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private encryptionService: EncryptionService,
  ) {
    this.sharedServices.getIsLoggedIn.subscribe((res) => {
      this.isLoggedIn = this.sharedServices.getLogedIn();
      this.selectedCity = this.getSelectedCityFromStorage();
      this.cd.detectChanges();
    });
    this.selectedCity = this.getSelectedCityFromStorage();
    this.sharedServices.getCityChanged.subscribe((city) => {
      this.selectedCity = city ?? this.getSelectedCityFromStorage();
      this.cd.detectChanges();
    });
  }
  private getSelectedCityFromStorage() {
    const encryptedCity = localStorage.getItem("selectedCity");
    if (!encryptedCity) {
      return null;
    }

    try {
      const decryptedCity = this.encryptionService.decryptUsingAES256(encryptedCity);
      if (!decryptedCity) {
        return null;
      }

      const parsedCity = JSON.parse(decryptedCity);
      const normalizedCity = typeof parsedCity === "string" ? JSON.parse(parsedCity) : parsedCity;

      if (!normalizedCity) {
        return null;
      }

      return {
        id: Number(normalizedCity.id ?? normalizedCity.Id ?? normalizedCity.CityId ?? 0),
        name: String(normalizedCity.name ?? normalizedCity.Name ?? normalizedCity.City ?? "").trim(),
      };
    } catch {
      return null;
    }
  }
  rangeValidator(group: AbstractControl): ValidationErrors | null {
    const start = group.get('range.start')?.value as Date | null;
    const end = group.get('range.end')?.value as Date | null;
    if (!start || !end) return null;
    return end >= start ? null : { rangeInvalid: true };
  }
  ngOnInit() {

    this.leadService.getLeadSelected.subscribe((res) => {

      this.isLeadSelected = res;
    });
    this.isLoggedIn = this.sharedServices.getLogedIn();
    this.leadService.getuserLogoutLogin.subscribe((res) => {

      this.isLoggedIn = this.sharedServices.getLogedIn();
      this.cd.detectChanges();
    });

  }

  ChangeCity() {
    this.dialog.open(AgentCityComponent, {
      width: "min(960px, 90vw)",
      maxWidth: "500px",
      hasBackdrop: true,
    });
  }


  myBackButton(title: string) {
    if (title == "Login" || title == "New User Registration") {
      this.modalCtrl.dismiss();
    } else {
      this.location.back();
    }
  }
  AddNewProp(isLeadSelected: string) {
    if (this.isLoggedIn) {
      if (isLeadSelected == "Lead") {
        this.router.navigate(["agent-home/add-new-agent-lead", 0]);
      } else if (isLeadSelected == "Property") {
        this.router.navigate(["agent-home/add-new-agent-property", 0]);
      }
      else {
        this.router.navigate(["agent-home/add-project", { action: 'add' }]);
      }
    } else {
      this.sharedServices.openUserLoginModal();
    }
  }
  myAccount() {
    if (this.isLoggedIn) {
      this.router.navigate(["agent-home/my-account"]);
    } else {
      this.sharedServices.openUserLoginModal();
    }
  }
  shortlist() {
    this.router.navigate(["agent-home/property-list", "Shortlist"]);
  }
  closeLoginDialog() {
    this.modalCtrl.dismiss();
  }
  // addInvitation(){
  // }
  exportProperties() {
    const dialogRef = this.dialog.open(ExportPropertyLeadsComponent, {
      // width: '420px',
      // maxWidth: '95vw',
      hasBackdrop: true,
      disableClose: true,
      autoFocus: false,
      backdropClass: "mat-dialog-blur-backdrop",
      data: {
        type: "Property",
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
    });
  }
  dismissdialog() {
    this.canDismiss = true;
  }

  openLinkLeadDialog() {
    const encryptedAgentId = this.encryptionService.encryptUsingAES256(
      parseInt(this.sharedServices.getAgentId())
    )?.replace(/\//g, '-').replace(/\+/g, '_').replace(/=/g, '~');

    const selectedType = this.isLeadSelected === 'Project' ? 'Project' : 'Lead';

    const url = selectedType === 'Project'
      ? domain.ShareBuilderPropertyForm + encryptedAgentId
      : domain.AddNewLinkLead + encryptedAgentId;

    this.dialog.open(DialogLinkLeadComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: false,
      // width: '480px',
      maxWidth: '95vw',
      data: { url, selectedType },
    });
  }
}
